import {CallJSSKey} from "@/Core/Bridge/CallJSSKey";
import Util from "@/Master/Util";
import GameMsgUtil from "@/app/(game)/GameMsgUtil";
import {GameMsgKey} from "@/app/(game)/GameMsgKey";

export default class CallTempData {
    static tag: string = `[CallJSS-临时数据]`;


    static tempMap: Map<string, any> = new Map();


    static getVal(key:string){
        if (this.tempMap.has(key)){
            return this.tempMap.get(key);
        }
        return '';
    }

    static setVal(key:string,val:any){
        this.tempMap.set(key,val);
        if (Util.isLog){
            console.log(this.tag, `key=${key},val=${val}`);
        }
    }

    static get getHeaderStr(): string {
        return this.getVal(CallJSSKey.Header);
    }

    static get getGameId(): number {
        return this.getVal(CallJSSKey.GameId);
    }



}